// extracted by mini-css-extract-plugin
export default {"headerContent":"HeaderBar_headerContent__IWz1k"};